import React from "react";
import classes from "./Spinner.module.css";

const Spinner: React.FC = () => <div className={classes.Loader}>Loading...</div>;

export default Spinner;
